import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import partnerOne from '../../assets/images/partner-one.png';
import partnerTwo from '../../assets/images/partner-two.png';
import partnerThree from '../../assets/images/partner-three.png';
import partnerFour from '../../assets/images/partner-four.png';
import partnerFive from '../../assets/images/partner-five.png';
import partnerSix from '../../assets/images/partner-six.png';

const options = {
    infinite: true,
    arrows: false,
    dots: false,
    speed: 2000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 4 } },
        { breakpoint: 768, settings: { slidesToShow: 3 } },
        { breakpoint: 576, settings: { slidesToShow: 2 } },
    ]
}
 
class PartnerLogo extends React.Component {
    render(){
        return null; // Hidden: placeholder partner logos
        /* eslint-disable no-unreachable */
        return (
            <div className="partner-area uk-section uk-padding-remove-top">
                <div className="uk-container">
                    {/* <div className="partner-slides"> */}
                    <Slider 
                        className="partner-slides"
                        {...options}
                    >
                        <div className="item">
                            <Link to="#">
                                <img src={partnerOne} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partnerTwo} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partnerThree} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partnerFour} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partnerFive} alt="Partner" />
                            </Link>
                        </div>

                        <div className="item">
                            <Link to="#">
                                <img src={partnerSix} alt="Partner" />
                            </Link>
                        </div>
                        </Slider>
                    {/* </div> */}
                </div>
            </div>
        );
    }
}
 
export default PartnerLogo;